import React from 'react';

import Box from '../Box'

export default props => {
    return (
        <section className="container">
            <Box {...props} id="b1" type="ABridTileNarrow" settings={props.settings.b1} uID={props.settings.uID} votingResult={props.settings.votingResult} classes="" />
        </section>
    );
}